import React from 'react';

import { PostOfficeSideNavMessageProvider } from '@post-office/browser--growth/confluence-side-nav/contexts/post-office-side-nav-message-provider';

import { RightSidebarContextProvider } from '@confluence/page-layout-context';
import { InProductHelpProvider } from '@confluence/in-product-help/entry-points/InProductHelpProvider.ts';
import { SnippetsProvider } from '@confluence/snippets/entry-points/SnippetsProvider.ts';
import { ApprovalsProvider } from '@confluence/approvals/entry-points/ApprovalsContext.ts';
import { SideNavigationCollapsedContainer } from '@confluence/page-layout-side-navigation-context/entry-points/SideNavigationCollapsedStore.ts';

import { useSideNavInitialState } from './useSideNavInitialState.ts';

type PageLayoutContextProviderWrapperPropsType = {
	children: React.ReactNode;
};

export const PageLayoutContextProviderWrapper = ({
	children,
}: PageLayoutContextProviderWrapperPropsType): React.JSX.Element => {
	const { initialCollapsedState } = useSideNavInitialState();

	return (
		<>
			{/*
			 * Seeds SideNavigationCollapsedStore from the user's persisted preference. Rendered before
			 * the provider tree — and so before TopNav and SideNavigation — so the store is correct on
			 * any consumer's first render rather than one frame late. `isGlobal` is required; see the
			 * container's docblock. Renders no DOM, so it cannot affect layout or SSR markup.
			 */}
			<SideNavigationCollapsedContainer
				isGlobal
				initialIsCollapsed={initialCollapsedState === 'collapsed'}
			/>
			<RightSidebarContextProvider>
				<PostOfficeSideNavMessageProvider>
					<InProductHelpProvider>
						<SnippetsProvider>
							<ApprovalsProvider>{children}</ApprovalsProvider>
						</SnippetsProvider>
					</InProductHelpProvider>
				</PostOfficeSideNavMessageProvider>
			</RightSidebarContextProvider>
		</>
	);
};
